<template>
  <div class="allWorks" v-show="total != 0">

    <div class="allWorks-con">
      <ul class="allWorks-style-title">
        <li v-for="(item, index) in worksStyle"
            @click="handleClick(item,index)"
            :class="{ 'active': activeNum == index }"
        >
          {{ item.name }}
        </li>
      </ul>

      <div class="swiper">
        <div class="prev" @click="arrowClick('prev')"></div>
        <el-carousel :autoplay="false" arrow="never" indicator-position="outside" ref="swiper"  trigger="click" @change="changeWorkList">
          <div @touchstart="start($event)" @touchmove="move($event)">
          <el-carousel-item v-for="item in carouselNum" :key="item">
            <ul class="swiper-con"  ref="swiperImg">
              <li v-for="(item, index) in allWorkList"  @click="toOpusInfoCom(item.work_id)" >
                <img :src="item.url" >
                <div class="reveal-info">
                  <p class="reveal-info-title">{{item.name}}</p>
                  <div class="reveal-info-con">
                    <span class="name">{{ item.nickname }}</span>
                    <span class="num">
                  <img src="../assets/images/thumbs-up.png" alt="">
                  {{ item.votes }}
                </span>
                  </div>
                </div>
              </li>
            </ul>
          </el-carousel-item>
          </div>
        </el-carousel>
        <div class="next" @click="arrowClick('next')"></div>
      </div>
      <div class="main-button" @click="toOpusReveal">
        <span>查看全部</span>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "AllWorks",
  data() {
    return {
      activeNum: 0,
      orderType: '3',
      worksStyle: [
        {name: '特邀作品展示', orderType: '3'},
        {name: '优秀作品展示', orderType: '0'},
        {name: '人气作品展示', orderType: '2'}
      ],
      page: '1',
      pageSize: '6',
      currentPage: 1,
      imgNum: 3,
      worksList: [],
      total: 0,
      carouselNum: 2,
      swiperImgHeight: '180px',
      startX: '',
      startY: '',
      moveY: '',
      moveX: '',
      startTime: '',
    }
  },
  mounted() {

    this.getWorksList()
    if(this.$store.state.isMobile){
      this.imgNum = 2;
    }else{
      this.imgNum = 3;
    }
    this.$nextTick(()=>{
      if(this.$refs.swiperImg){
        let $ele = this.$refs.swiperImg[0];
        let width;
        if(this.$store.state.isMobile){
          width = $ele.clientWidth * 0.48;
        }else{
          width = $ele.clientWidth * 0.32;
        }
        this.swiperImgHeight = width/16*9 + 'px'
      }
    })
  },
  computed: {
      allWorkList: function() {
        return this.worksList.slice((this.currentPage -1) * this.imgNum, this.currentPage * this.imgNum);
      }
  },
  methods: {
    handleClick(tab, index) {
      // this.slideBanner();
      console.log(index)
      this.currentPage=1
      this.activeNum = index;
      this.orderType = tab.orderType
      this.getWorksList()
    },
    changeWorkList(e) {
      console.log(e)
      this.currentPage = e+1
    },
    arrowClick(val) {
      if (val === 'next') {
        console.log(this.currentPage)
        this.$refs.swiper.next()
        if(this.$store.state.isMobile){
          this.startTime = new Date().getTime() + 500;
        }
      } else {
        this.$refs.swiper.prev()
        if(this.$store.state.isMobile){
          this.startTime = new Date().getTime() + 500;
        }
      }
    },
    toOpusInfoCom(workId) {
      //改变workId
      this.$tool.setLS('workId', workId, 1)
      this.$router.push({path: '/opusInfo', query: {id: workId}});
    },
    toOpusReveal() {
      this.$router.push({path: '/opusReveal'});
    },
    // 获取作品列表
    getWorksList() {
      this.$api.worksList(this.page, this.pageSize, this.orderType)
          .then(res => {
            if (res.data.items.length !== 0) {
              this.total = res.data.total;
              this.worksList = res.data.items;
              if(this.$store.state.isMobile){
                if (this.worksList.length <= 2) {
                  this.carouselNum = 1
                } else if (this.worksList.length > 2 && this.worksList.length <= 4) {
                  this.carouselNum = 2
                }else{
                  this.carouselNum = 3
                }
              }else {
                if (this.worksList.length <= 3) {
                  this.carouselNum = 1
                } else {
                  this.carouselNum = 2
                }
              }
            } else {
              this.worksList = [];
            }
          })
    },
    start(e) {
      this.startX = e.touches[0].clientX;
      this.startY = e.touches[0].clientY;
    },
    move(e) {
      this.moveX = e.touches[0].clientX;
      this.moveY = e.touches[0].clientY;
      var nowtime = new Date().getTime();
      if (this.startTime == undefined || nowtime > this.startTime) {
        if (this.startX - this.moveX <= 0) { // 右滑触发
          this.arrowClick('prev');
          return false;
        } else {
          this.arrowClick('next');
          return false;
        }
      }
    },
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/AllWorks/pc";
@import "../assets/css/AllWorks/wap";
</style>
